<template>
  <div class="page-container" ref="Home" id="homecontainer" v-images-loaded="loaded">
    <div class="bigscroller">
      <Menu />
      <MobileMenu />
      <section id="producto">
        <span class="top watcher" v-observe-visibility="{callback: visibilityChanged, throttle: 300,}"></span>
        <Product />
        <span class="bottom watcher" v-observe-visibility="{callback: visibilityChanged, throttle: 300,}"></span>
      </section>
      <section id="retailers">
        <span class="top watcher" v-observe-visibility="{callback: visibilityChanged, throttle: 300,}"></span>
        <Retailers />
        <MobileCerveza />
        <span class="bottom watcher" v-observe-visibility="{callback: visibilityChanged, throttle: 300,}"></span>
      </section>
      <section id="elaboracion">
        <span class="top watcher" v-observe-visibility="{callback: visibilityChanged, throttle: 300,}"></span>
        <MobileElaboration />
        <Elaboration />
        <span class="bottom watcher" v-observe-visibility="{callback: visibilityChanged, throttle: 300,}"></span>
      </section>
      <section id="ritualdeservido">
        <span class="top watcher" v-observe-visibility="{callback: visibilityChanged, throttle: 300,}"></span>
        <Ritual />
        <span class="bottom watcher" v-observe-visibility="{callback: visibilityChanged, throttle: 300,}"></span>
      </section>
      <section id="maridaje">
        <span class="top watcher" v-observe-visibility="{callback: visibilityChanged, throttle: 300,}"></span>
        <MobileMaridaje />
        <Maridaje />
        <span class="bottom watcher" v-observe-visibility="{callback: visibilityChanged, throttle: 300,}"></span>
      </section>
      <section id="campaign">
        <span class="top watcher" v-observe-visibility="{callback: visibilityChanged, throttle: 300,}"></span>
        <MobileCampaign />
        <Campaign />
        <span class="bottom watcher" v-observe-visibility="{callback: visibilityChanged, throttle: 300,}"></span>
      </section>
      <Footer />
      <MobileFooter />
    </div>
    <ModalAH v-show="showAlcohol" v-bind:wichModal="'alcoholandhealth'" @close="showAlcohol = false"></ModalAH>
    <Modal v-if="showModal" v-bind:wichModal="'register'" @close="showModal = false" @openTerms="showTerms = true"
      @openPrivacy="showPrivacy = true" />
    <Modal v-if="showTerms" v-bind:wichModal="'terms'" @close="showTerms = false" />

    <Modal v-if="showPrivacy" v-bind:wichModal="'politics'" @close="showPrivacy = false" />
  </div>
</template>

<script>
import Menu from "@/components/Menu";
import MobileMenu from "@/components/MobileMenu";
import VueScrollTo from "vue-scrollto";
import { mapActions, mapGetters } from "vuex";
import Footer from "@/components/FooterHome";
import MobileFooter from "@/components/MobileFooterHome.vue";
import tagFunctions from '@/utils/tagFunctions.js';
import imagesLoaded from 'vue-images-loaded'
import Product from "@/components/Product";
import Retailers from "@/components/Retailers";
import MobileCerveza from "@/components/MobileCerveza";
import Elaboration from "@/components/Elaboration";
import MobileElaboration from "@/components/MobileElaboration";
import Maridaje from "@/components/Maridaje";
import Campaign from "@/components/Campaign";
import Ritual from "@/components/Ritual";
import MobileMaridaje from "@/components/MobileMaridaje";
import MobileCampaign from "@/components/MobileCampaign";
import Modal from "@/components/Modal";
import ModalAH from "@/components/ModalAH.vue";

const utm = {
  utm_content: "QR_AvisoAlcohol",
  utm_medium: "PopUp",
  utm_source: "Lata-Tecate00",
}

export default {
  name: "Home",
  props: ["id"],
  components: {
    Menu,
    MobileMenu,
    Footer,
    MobileFooter,
    Product,
    MobileCerveza,
    Retailers,
    Elaboration,
    Maridaje,
    Ritual,
    Campaign,
    MobileElaboration,
    MobileMaridaje,
    MobileCampaign,
    Modal,
    ModalAH,
  },
  directives: {
    imagesLoaded
  },
  computed: {
    ...mapGetters([
      "getActiveSection",
      "getTriggerSpring",
      "getEdgeScrolling",
      "getScrollMotion",
    ]),
  },
  created() { },
  data() {
    return {
      showModal: false,
      wichModal: "",
      fixedLel: true,
      showTerms: false,
      showPrivacy: false,
      showAlcohol: false,
      placesDirections: {
        productoUp: (scrolled) => {
          this.setActiveSection("producto");
          document.getElementById("app").scroll(0, scrolled);
        },
        productoDown: (scrolled) => {
          this.setActiveSection("producto");
          document.getElementById("app").scroll(0, scrolled);
        },
        // campaignUp: (scrolled) => {
        //   this.setActiveSection("campaign");
        //   document.getElementById("app").scroll(0, scrolled);
        // },
        // campaignDown: (scrolled) => {
        //   this.setActiveSection("campaign");
        //   document.getElementById("app").scroll(0, scrolled);
        // },
      },
    };
  },
  mounted() {
    this.setLoadStatus({ status: false })
    tagFunctions.evAuthenticationPush("Tecate 0.0");
    tagFunctions.evPageViewPush('Home')
    // console.log(this.$route.query)
    const {utm_source, utm_medium, utm_content} = this.$route.query;
    if((utm['utm_source'] === utm_source) && utm['utm_content'] === utm_content && utm['utm_medium'] === utm_medium ) {
      //console.log('show pop up')
      setTimeout(() => {
        this.showAlcohol = true
      }, 3000);
    }
    //this.checkRouteForInitialScroll();
    

    this.lazyShowModal()

    if (isVisible) {
        //debugger
        this.$router.push({ name: 'Routes', params: { id: 'producto' } }).catch(err => {
          // Ignore the vuex err regarding  navigating to the page they are already on.
          if (
            err.name !== 'NavigationDuplicated' &&
            !err.message.includes('Avoided redundant navigation to current location')
          ) {
            // But print any other errors to the console
            throw err;
          }
        });
        this.setActiveSection({
          willScroll: false,
          section: 'producto',
        });
      }

      VueScrollTo.scrollTo(`#app`, 1, {
      container: "body",
      easing: "linear",
      offset: 0,
      force: true,
      cancelable: true,
      // onStart: function(element) {},
      // onDone: function(element) {},
      // onCancel: function() {},
      x: false,
      y: true,
    });
  },
  methods: {
    loaded() {
      this.setLoadStatus({ status: true })
    },
    lazyShowModal() {
      const userId = localStorage.getItem('user');
      if(!userId){
        setTimeout(() => {
        this.showModal = true;
      }, 10000);
      }
   
    },
    ...mapActions({
      goToSection: "goToSection",
      setActiveSection: "setActiveSection",
      resetEdgeScrollingAction: "resetEdgeScrolling",
      setEdgeScrollingAction: "setEdgeScrolling",
      setLoadStatus: "setLoadStatus"
    }),
    popUpModal(modalType) {
      this.showModal = true;
      this.wichModal = modalType;
    },
    visibilityChanged(isVisible, entry) {
      //  console.log("isvisible1",entry.target.offsetParent)
      if (isVisible) {
        //debugger
        this.$router.push({ name: 'Routes', params: { id: entry.target.offsetParent.id }, query: this.$route.query }).catch(err => {
          // Ignore the vuex err regarding  navigating to the page they are already on.
          if (
            err.name !== 'NavigationDuplicated' &&
            !err.message.includes('Avoided redundant navigation to current location')
          ) {
            // But print any other errors to the console
            throw err;
          }
        });
        this.setActiveSection({
          willScroll: false,
          section: entry.target.offsetParent.id,
        });
        switch (entry.target.offsetParent.id ) {
          case 'producto' :
            twq('event', 'tw-oe6c6-oe6d4', {
            contents: [
              {
                content_type: null,
                content_id: 'oe6d4',
                content_name: 'Home',
                content_price: null,
                num_items: null,
                content_group_id: null
              }] 
            });
            twq('event', 'tw-oe6c6-oe6d0', {
            contents: [
              {
                content_type: null,
                content_id: 'oe6d0',
                content_name: 'Producto',
                content_price: null,
                num_items: null,
                content_group_id: null
              }] 
            });
            fbq('trackCustom', 'ProductoPageTecate0.0');
            pintrk('track', 'pagevisit', {property: 'Producto'});
          break;
          case 'retailers' :
            twq('event', 'tw-oe6c6-oe6cb', {
            contents: [
              {
                content_type: null,
                content_id: 'oe6cb',
                content_name: 'Retailers',
                content_price: null,
                num_items: null,
                content_group_id: null
              }] 
            });
            fbq('trackCustom', 'RetailersPageTecate0.0');
            pintrk('track', 'pagevisit', {property: 'Retailers'});
          break;
          case 'elaboracion':
            twq('event', 'tw-oe6c6-oe6cw', {
            contents: [
              {
                content_type: null,
                content_id: 'oe6cw',
                content_name: 'Elaboracion',
                content_price: null,
                num_items: null,
                content_group_id: null
              }] 
            });
            fbq('trackCustom', 'ElaboracionPageTecate0.0');
            pintrk('track', 'pagevisit', {property: 'Elaboracion'});
          break;
          case 'ritualdeservido':
            twq('event', 'tw-oe6c6-oe6cv', {
            contents: [
              {
                content_type: null,
                content_id: 'oe6cv',
                content_name: 'Ritual de Servido',
                content_price: null,
                num_items: null,
                content_group_id: null
              }] 
            });
            fbq('trackCustom', 'RitualdeServidoPageTecate0.0');
            pintrk('track', 'pagevisit', {property: 'RitualdeServido'});
          break;
          case 'maridaje' :
            twq('event', 'tw-oe6c6-oe6ct', {
            contents: [
              {
                content_type: null,
                content_id: 'oe6ct',
                content_name: 'Maridaje',
                content_price: null,
                num_items: null,
                content_group_id: null
              }] 
            });
            fbq('trackCustom', 'MaridajePageTecate0.0');
            pintrk('track', 'pagevisit', {property: 'Maridaje'});
          break;
          case 'campaign' :
            twq('event', 'tw-oe6c6-oe6ci', {
            contents: [
              {
                content_type: null,
                content_id: 'oe6ci',
                content_name: 'Campaña',
                content_price: null,
                num_items: null,
                content_group_id: null
              }] 
            });
            fbq('trackCustom', 'CampañaPageTecate0.0');
            pintrk('track', 'pagevisit', {property: 'Campaña'});
          break;
          default :
          break;
        }
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "~@/styles/containers/Home.scss";
@import "~@/styles/variables.scss";
</style>
